<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col sm="11">
        <v-sheet rounded="xl" class="ma-0 chapter-list-item">
          <v-container>
            <v-row align="center" justify="center">
              <v-col md="1">
                <div
                  class="d-flex flex-column justify-space-between align-center text-center"
                  v-if="chapter.chapterConnectorsTo.length == 0 && startChapter"
                >
                  {{ $t("chapter.start") }} <br /><v-icon>mdi-file</v-icon>
                  <v-img
                    width="20px"
                    :src="require('@/assets/chapterStart.svg')"
                  >
                  </v-img>
                </div>
                <div
                  class="d-flex flex-column justify-space-between align-center text-center"
                  v-else-if="chapter.chapterConnectors.length == 0"
                >
                  {{ $t("chapter.end") }} <br /><v-icon>mdi-file</v-icon>
                  <v-img
                    width="20px"
                    :src="require('@/assets/chapterStart.svg')"
                  >
                  </v-img>
                </div>
                <div
                  class="d-flex flex-column justify-space-between align-center text-center"
                  v-else
                >
                  <v-icon>mdi-file</v-icon>
                </div>
              </v-col>
              <v-col>
                <UpdateChapterTitleTextField
                  :iri="chapter.id"
                  :name="chapter.name"
                />
              </v-col>
              <v-col class="location-info"
                ><h1>{{ $t("chapter.location") }}</h1>
                <span v-if="chapter.place">{{ chapter.place.name }}</span>
                <span v-else>{{ $t("chapter.noLocation") }}</span>
              </v-col>
              <v-col style="border-left: 1px solid black"
                ><h1>{{ $t("chapter.connections") }}</h1>
                <v-chip color="secondaryAction">
                  <div class="connections-chip-contents">
                    {{
                      chapter.chapterConnectors.length +
                      chapter.chapterConnectorsTo.length
                    }}
                  </div>
                </v-chip></v-col
              >
            </v-row>
          </v-container>
        </v-sheet>
      </v-col>
      <v-col>
        <v-img
          :src="require('@/assets/outgoingConnectionPip.svg')"
          class="outgoing-pip connection-pip"
          contain
          :height="pipSize"
          :width="pipSize"
        />
        <v-img
          :src="require('@/assets/incomingConnectionPip.svg')"
          class="incoming-pip connection-pip"
          contain
          :height="pipSize"
          :width="pipSize"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import UpdateChapterTitleTextField from "./UpdateChapterTitleTextField";
export default {
  data() {
    return {
      pipSize: "25px",
    };
  },
  components: {
    UpdateChapterTitleTextField,
  },
  props: {
    chapter: Object,
    startChapter: Boolean,
  },
};
</script>
<style scoped>
h1 {
  font-weight: 300;
  font-size: 16px;
}

.location-info span {
  font-weight: 500;
  font-size: 18px;
}

.connections-chip-contents {
  width: 90px;
  color: white;
}

.chapter-list-item h1,
.chapter-list-item h2 {
  text-align: center;
}
.v-sheet {
  background-color: var(--v-background-base);
}

.chapter-list-item {
  border: 4px solid transparent;
  padding: 0px;
}

.active .chapter-list-item {
  border-color: var(--v-primaryAction-base);
}

.incoming .chapter-list-item,
.outgoing .chapter-list-item {
  border: 2px solid;
  padding: 2px;
}
.incoming .chapter-list-item {
  border-color: #00bdc9;
}
.outgoing .chapter-list-item {
  border-color: #29c900;
}

.incoming-pip,
.outgoing-pip {
  display: none;
}

.incoming .incoming-pip {
  display: inline-block;
}
.outgoing .outgoing-pip {
  display: inline-block;
}
</style>